<div fxLayout="row" fxLayoutAlign="start center">
    <button mat-mini-fab fxFlex="0 1 auto"
        fxLayoutAlign="center center"
        class="ml-12" color="accent"
        (click)="returnTo(returnToEnum.parent)"
        [disabled]="!directories.length || isLoading || disabled"
        matTooltip="{{'FILE-NAVIGATION.RETURN.PARENT' | translate:{parentName: getParentName()} }}"
        matTooltipPosition="above">
        <mat-icon class="mr-4">subdirectory_arrow_left</mat-icon>
    </button>
    <div fxFlex="1 1" fxLayout="row wrap" fxLayoutAlign="start center" class="mat-elevation-z1 m-12 border-r back">
        <button mat-mini-fab fxFlex="0 1 auto"
            fxLayoutAlign="center center"
            class="m-8 ml-12" color="accent"
            (click)="returnTo(returnToEnum.home)"
            [disabled]="!directories.length || isLoading || disabled"
            matTooltip="{{'FILE-NAVIGATION.RETURN.HOME' | translate}}"
            matTooltipPosition="above">
            <mat-icon class="">home</mat-icon>
        </button>
        
        <div *ngIf="isLoading" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon class="secondary-text mr-12">chevron_right</mat-icon>
            <fading-loading-animation>
                <mat-icon class="secondary-text">more_horiz</mat-icon>
            </fading-loading-animation>
        </div>
        
        <ng-container *ngIf="!isLoading">
            <div *ngIf="directories.length > maxDisplay" fxLayout="row" fxLayoutAlign="center center">
                <mat-icon class="secondary-text mr-12">chevron_right</mat-icon>
                <mat-icon class="secondary-text">more_horiz</mat-icon>
            </div>
            <ng-container *ngFor="let directory of directories; index as i; count as c; last as isLast">
                <div *ngIf="c <= maxDisplay || (c > maxDisplay && (i >= (c - maxDisplay)))" 
                    fxFlex="0 1 150px" fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon class="secondary-text mr-12">chevron_right</mat-icon>
                    <mat-icon [color]="isLast ? 'accent' : ''" class="secondary-text mr-8">folder</mat-icon>
                    <span [class]="isLast ? '' : 'secondary-text'" class="text-truncate">{{directory}}</span>
                </div>
            </ng-container>
        </ng-container>
        
    </div>
</div>
